import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../layouts/page';
import Spinner from '../../components/spinner';
import { config } from '../../config';
import Backbtn from '../../components/backbtn';

const NoticeboardView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [noticeboard, setNoticeboard] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to truncate text to a given word limit
  const truncateText = (htmlString, wordLimit) => {
    if (!htmlString) return '';
    
    // Strip HTML tags
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    // Truncate text to the word limit
    const words = text.split(/\s+/).slice(0, wordLimit).join(' ');
    return words + (text.split(/\s+/).length > wordLimit ? '...' : '');
  };

  // Fetch noticeboard details
  const fetchNoticeboardDetails = async () => {
    const token = localStorage.getItem('auth_token');
    try {
      const response = await axios.get(`${config.api_path}/estate-noticeboards/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNoticeboard(response.data.data);
    } catch (error) {
      console.error('Error fetching noticeboard details:', error);
      toast.error('Failed to load noticeboard details. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = 'Tuwe | View Noticeboard';
    fetchNoticeboardDetails();
  }, [id]);

  return (
    <Layout>
      <div className="col-12 grid-margin">
        {loading ? (
          <Spinner />
        ) : (
          <div className="card noticeboard-card">
            <h3 style={{ textAlign: "center" }}>NoticeBoard</h3>
            <Backbtn />
            <div className="card-body noticeboard-content"> 
              <div className="noticeboard-image">
                <img
                  src={noticeboard.image}
                  alt="Estate"
                  className="img-fluid"
                />
              </div>
              <div className="noticeboard-details">
                <h4 className="noticeboard-title">{noticeboard.title}</h4>
                <h6 className="noticeboard-subtitle">{noticeboard.sub_title}</h6>
                
                {/* Brief section with word limit applied */}
                <div className="noticeboard-brief">
                  <strong>Brief:</strong>
                  <p>{truncateText(noticeboard.brief, 50)}</p>
                </div>

                <div className="noticeboard-message">
                  <strong>Message:</strong>
                  <p>{noticeboard.message_body}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </Layout>
  );
};

export default NoticeboardView;
